import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: `${theme.spacing(0.125)} solid #dadada`,
    paddingBottom: theme.spacing(2),
  },
}));

export default useStyles;
